import { useCurrentUserData } from 'shared/hooks/useCurrentUserData';
import { useSearchParams } from 'shared/hooks/useSearchParams';

export const TENANT_ID_URL_PARAM = 'tenantId';

export function useSelectedTenant() {
  const [{ data }] = useCurrentUserData();

  const tenants = data?.tenants ?? [];
  const urlSelectedTenantId = useSearchParams().get(TENANT_ID_URL_PARAM);
  const urlSelectedTenant = urlSelectedTenantId
    ? tenants.find((x) => x.id === urlSelectedTenantId)
    : undefined;
  const selectedTenant = tenants.find(
    (x) => x.id === data?.currentUser.selectedTenantId,
  );

  return { selectedTenant, urlSelectedTenant, urlSelectedTenantId };
}
